var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"px-3 md:px-10"},[_c('h2',{staticClass:"font-bold text-lg mt-3"},[_vm._v("ČR se připravuje.")])])])}]

export { render, staticRenderFns }